import Exchange from '@ui/features/Exchange';
import { useTranslation } from 'next-i18next';
import { Flex, HStack, VStack } from 'styled-system/jsx';
import { Text } from '@ui/lib/park/ui/text';

import { RedeemFees } from './RedeemFees';
import { DailyRedeemLimit } from './DailyRedeemLimit';
import { useDailyRedeemLimit } from './useDailyRedeemLimit';
import { HLine } from '@ui/components/Line';

export const FastRedeem = () => {
  const { t } = useTranslation();
  const { totalLimit, remaining, nextResetTime, isExceeded, status } = useDailyRedeemLimit();

  return (
    <>
      <VStack w="full" gap={1}>
        <Exchange.Input />
        <DailyRedeemLimit 
          totalLimit={totalLimit}
          remaining={remaining}
          nextResetTime={nextResetTime}
          isExceeded={isExceeded}
          status={status}
        />
        <HLine w="full" />
        <Exchange.Redeem.TextOutput />
        <RedeemFees />
      </VStack>
      <Exchange.ExecuteButton label="Redeem" disabled={isExceeded} />
    </>
  );
};
